/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateRoleRequestDto,
  ListRolesResponseDto,
  ListRolesWithPermissionsResponseDto,
  RoleDeletionImpactResponseDto,
  RoleDetailResponseDto,
  SetRolePermissionsRequestDto,
  UpdateRoleRequestDto,
} from '../models/index';
import {
    CreateRoleRequestDtoFromJSON,
    CreateRoleRequestDtoToJSON,
    ListRolesResponseDtoFromJSON,
    ListRolesResponseDtoToJSON,
    ListRolesWithPermissionsResponseDtoFromJSON,
    ListRolesWithPermissionsResponseDtoToJSON,
    RoleDeletionImpactResponseDtoFromJSON,
    RoleDeletionImpactResponseDtoToJSON,
    RoleDetailResponseDtoFromJSON,
    RoleDetailResponseDtoToJSON,
    SetRolePermissionsRequestDtoFromJSON,
    SetRolePermissionsRequestDtoToJSON,
    UpdateRoleRequestDtoFromJSON,
    UpdateRoleRequestDtoToJSON,
} from '../models/index';

export interface RoleControllerCreateRoleRequest {
    organizationId: string;
    createRoleRequestDto: CreateRoleRequestDto;
}

export interface RoleControllerDeleteRoleRequest {
    roleId: string;
    organizationId: string;
    fallbackRoleId?: string;
}

export interface RoleControllerFindRoleByIdRequest {
    roleId: string;
    organizationId: string;
}

export interface RoleControllerFindRoleDeletionImpactRequest {
    roleId: string;
    organizationId: string;
}

export interface RoleControllerListRolesRequest {
    limit: number;
    page: number;
    organizationId: string;
    q?: string;
}

export interface RoleControllerListRolesWithPermissionsRequest {
    organizationId: string;
}

export interface RoleControllerSetRolePermissionsRequest {
    roleId: string;
    organizationId: string;
    setRolePermissionsRequestDto: SetRolePermissionsRequestDto;
}

export interface RoleControllerUpdateRoleRequest {
    roleId: string;
    organizationId: string;
    updateRoleRequestDto: UpdateRoleRequestDto;
}

/**
 * 
 */
export class RolesApi extends runtime.BaseAPI {

    /**
     */
    async roleControllerCreateRoleRaw(requestParameters: RoleControllerCreateRoleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleDetailResponseDto>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling roleControllerCreateRole().'
            );
        }

        if (requestParameters['createRoleRequestDto'] == null) {
            throw new runtime.RequiredError(
                'createRoleRequestDto',
                'Required parameter "createRoleRequestDto" was null or undefined when calling roleControllerCreateRole().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organizations/{organizationId}/roles`;
        urlPath = urlPath.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateRoleRequestDtoToJSON(requestParameters['createRoleRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleDetailResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async roleControllerCreateRole(requestParameters: RoleControllerCreateRoleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleDetailResponseDto> {
        const response = await this.roleControllerCreateRoleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async roleControllerDeleteRoleRaw(requestParameters: RoleControllerDeleteRoleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['roleId'] == null) {
            throw new runtime.RequiredError(
                'roleId',
                'Required parameter "roleId" was null or undefined when calling roleControllerDeleteRole().'
            );
        }

        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling roleControllerDeleteRole().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['fallbackRoleId'] != null) {
            queryParameters['fallbackRoleId'] = requestParameters['fallbackRoleId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organizations/{organizationId}/roles/{roleId}`;
        urlPath = urlPath.replace(`{${"roleId"}}`, encodeURIComponent(String(requestParameters['roleId'])));
        urlPath = urlPath.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async roleControllerDeleteRole(requestParameters: RoleControllerDeleteRoleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.roleControllerDeleteRoleRaw(requestParameters, initOverrides);
    }

    /**
     */
    async roleControllerFindRoleByIdRaw(requestParameters: RoleControllerFindRoleByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleDetailResponseDto>> {
        if (requestParameters['roleId'] == null) {
            throw new runtime.RequiredError(
                'roleId',
                'Required parameter "roleId" was null or undefined when calling roleControllerFindRoleById().'
            );
        }

        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling roleControllerFindRoleById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organizations/{organizationId}/roles/{roleId}`;
        urlPath = urlPath.replace(`{${"roleId"}}`, encodeURIComponent(String(requestParameters['roleId'])));
        urlPath = urlPath.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleDetailResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async roleControllerFindRoleById(requestParameters: RoleControllerFindRoleByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleDetailResponseDto> {
        const response = await this.roleControllerFindRoleByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async roleControllerFindRoleDeletionImpactRaw(requestParameters: RoleControllerFindRoleDeletionImpactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleDeletionImpactResponseDto>> {
        if (requestParameters['roleId'] == null) {
            throw new runtime.RequiredError(
                'roleId',
                'Required parameter "roleId" was null or undefined when calling roleControllerFindRoleDeletionImpact().'
            );
        }

        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling roleControllerFindRoleDeletionImpact().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organizations/{organizationId}/roles/{roleId}/deletion-impact`;
        urlPath = urlPath.replace(`{${"roleId"}}`, encodeURIComponent(String(requestParameters['roleId'])));
        urlPath = urlPath.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleDeletionImpactResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async roleControllerFindRoleDeletionImpact(requestParameters: RoleControllerFindRoleDeletionImpactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleDeletionImpactResponseDto> {
        const response = await this.roleControllerFindRoleDeletionImpactRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async roleControllerListRolesRaw(requestParameters: RoleControllerListRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListRolesResponseDto>> {
        if (requestParameters['limit'] == null) {
            throw new runtime.RequiredError(
                'limit',
                'Required parameter "limit" was null or undefined when calling roleControllerListRoles().'
            );
        }

        if (requestParameters['page'] == null) {
            throw new runtime.RequiredError(
                'page',
                'Required parameter "page" was null or undefined when calling roleControllerListRoles().'
            );
        }

        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling roleControllerListRoles().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organizations/{organizationId}/roles`;
        urlPath = urlPath.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListRolesResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async roleControllerListRoles(requestParameters: RoleControllerListRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListRolesResponseDto> {
        const response = await this.roleControllerListRolesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async roleControllerListRolesWithPermissionsRaw(requestParameters: RoleControllerListRolesWithPermissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListRolesWithPermissionsResponseDto>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling roleControllerListRolesWithPermissions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organizations/{organizationId}/roles/with-permissions`;
        urlPath = urlPath.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListRolesWithPermissionsResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async roleControllerListRolesWithPermissions(requestParameters: RoleControllerListRolesWithPermissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListRolesWithPermissionsResponseDto> {
        const response = await this.roleControllerListRolesWithPermissionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async roleControllerSetRolePermissionsRaw(requestParameters: RoleControllerSetRolePermissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleDetailResponseDto>> {
        if (requestParameters['roleId'] == null) {
            throw new runtime.RequiredError(
                'roleId',
                'Required parameter "roleId" was null or undefined when calling roleControllerSetRolePermissions().'
            );
        }

        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling roleControllerSetRolePermissions().'
            );
        }

        if (requestParameters['setRolePermissionsRequestDto'] == null) {
            throw new runtime.RequiredError(
                'setRolePermissionsRequestDto',
                'Required parameter "setRolePermissionsRequestDto" was null or undefined when calling roleControllerSetRolePermissions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organizations/{organizationId}/roles/{roleId}/permissions`;
        urlPath = urlPath.replace(`{${"roleId"}}`, encodeURIComponent(String(requestParameters['roleId'])));
        urlPath = urlPath.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SetRolePermissionsRequestDtoToJSON(requestParameters['setRolePermissionsRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleDetailResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async roleControllerSetRolePermissions(requestParameters: RoleControllerSetRolePermissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleDetailResponseDto> {
        const response = await this.roleControllerSetRolePermissionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async roleControllerUpdateRoleRaw(requestParameters: RoleControllerUpdateRoleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleDetailResponseDto>> {
        if (requestParameters['roleId'] == null) {
            throw new runtime.RequiredError(
                'roleId',
                'Required parameter "roleId" was null or undefined when calling roleControllerUpdateRole().'
            );
        }

        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling roleControllerUpdateRole().'
            );
        }

        if (requestParameters['updateRoleRequestDto'] == null) {
            throw new runtime.RequiredError(
                'updateRoleRequestDto',
                'Required parameter "updateRoleRequestDto" was null or undefined when calling roleControllerUpdateRole().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/organizations/{organizationId}/roles/{roleId}`;
        urlPath = urlPath.replace(`{${"roleId"}}`, encodeURIComponent(String(requestParameters['roleId'])));
        urlPath = urlPath.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateRoleRequestDtoToJSON(requestParameters['updateRoleRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleDetailResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async roleControllerUpdateRole(requestParameters: RoleControllerUpdateRoleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleDetailResponseDto> {
        const response = await this.roleControllerUpdateRoleRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
